import {
Button,
Modal,
Switch,
} from "@mui/joy";
import { WHITE } from "../../../appConstants";
import React, {
Dispatch,
SetStateAction,
useEffect,
useState,
} from "react";
import CrossIcon from "../../../svg/Ads_Dashboard_Developement2/CrossIcon/elements.svg";

type journey_1_Props = {
id: string;
name: string;
}
type AddKeywordTypeProps = {
setToggle: Dispatch<SetStateAction<boolean>>;
DrillThroughHandler: (name: string) => void;
};

const DrillThroughJourneyModal: React.FC<AddKeywordTypeProps> = ({
setToggle,
DrillThroughHandler
}) => {

    const [journey_1, setJourney_1] = useState<journey_1_Props[]>([
        { id : '01', name: 'Principal Category'},
        { id : '02', name: 'Main Category'},
        { id : '03', name: 'Category'},
        { id : '04', name: 'Sub Category'},
        { id : '05', name: 'Product Name'},
        { id : '06', name: 'Style Code'},
        { id : '07', name: 'Model Code'},
        { id : '08', name: 'Variant Code'},
        { id : '09', name: 'SKU ID'},
        { id: '10', name: 'Platfom Code'},
        { id: '11', name: 'Campaign Name'},
        { id: '12', name: 'Ad Group Name'},
        { id: '13', name: 'Targeting & Match Type'},
        { id: '14', name: 'Customer Search Term'},
    ]);

    const [journey_2, setJourney_2] = useState<journey_1_Props[]>([
        { id : '01', name: 'Principal Category'},
        { id : '02', name: 'Main Category'},
        { id : '03', name: 'Category'},
        { id : '04', name: 'Sub Category'},
        { id : '05', name: 'Product Name'},
        { id : '06', name: 'Style Code'},
        { id : '07', name: 'Model Code'},
        { id : '08', name: 'Variant Code'},
        { id : '09', name: 'SKU ID'},
        { id: '10', name: 'Platfom Code'},
        { id: '11', name: 'Campaign Name'},
        { id: '12', name: 'Placement'},
    ]);

    const [journey_3, setJourney_3] = useState<journey_1_Props[]>([
        { id : '01', name: 'Principal Category'},
        { id : '02', name: 'Main Category'},
        { id : '03', name: 'Category'},
        { id : '04', name: 'Sub Category'},
        { id : '05', name: 'Product Name'},
        { id: '06', name: 'Campaign Name'},
        { id: '07', name: 'Ad Group Name'},
        { id: '08', name: 'Targeting & Match Type'},
        { id: '09', name: 'Customer Search Term'},
    ]);

    const [journey_4, setJourney_4] = useState<journey_1_Props[]>([
        { id : '01', name: 'Principal Category'},
        { id : '02', name: 'Main Category'},
        { id : '03', name: 'Category'},
        { id : '04', name: 'Sub Category'},
        { id : '05', name: 'Product Name'},
        { id: '06', name: 'Campaign Name'},
        { id: '07', name: 'Placement'},
    ]);

    const [openJourneyPath, setOpenJourneyPath] = useState<string>("");

    const openJourneyPathHandler = (journey_name: string) => {
        if(openJourneyPath === journey_name){
            setOpenJourneyPath("");
        }
        else if(openJourneyPath !== journey_name){
            setOpenJourneyPath(journey_name);
        }
    }

    return ( 
        <Modal
        open={true}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        className="h-full"
        >
        <div className="relative">
            <div
            style={{
                width: 840,
                height: 616,
                paddingLeft: 40,
                paddingRight: 40,
                paddingBottom: 40,
                paddingTop: 52,
                backgroundColor: `${WHITE.W_100}`,
            }}
            className="flex flex-col items-center justify-between rounded-[16px] gap-10"
            >
                
            <div className="flex flex-col gap-1 w-full">
                <div
                className="self-stretch"
                style={{
                    color: `#1C1C1E`,
                    fontSize: 20,
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "26px",
                }}
                >
                Choose A Journey
                </div>
                <div
                className="self-stetch"
                style={{
                    color: `#97979A`,
                    fontSize: 14,
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "22px",
                }}
                >
                Select a product journey to explore further details
                </div>
            </div>
            
            <div className="flex flex-col items-start gap-4 self-stretch" style={{
                overflowY:"auto",
                scrollbarWidth:"none"
            }}>

                <div className="flex flex-col items-center self-stretch rounded-[8px] relative" style={{
                    border: openJourneyPath === "journey_1" ? "1px solid #1565C0" : "1px solid #EAEAED",
                    backgroundColor: "#FFF",
                    boxShadow: openJourneyPath === "journey_1" ? "0px 4px 16px 6px rgba(21, 101, 192, 0.05)"  : "none"
                }}
                >
                    <div className="p-4 rounded-[8px] flex flex-col w-full gap-1 " 
                    onClick={() => openJourneyPathHandler("journey_1")}
                    >
                        <div
                        style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "20px",
                        }}
                        >
                        Match Type & CST View By Platform Code
                        </div>
                        <div
                        style={{
                            color: "var(--Text-Primary-Grey, #97979A)",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "18px",
                        }}
                        >
                        Use platform code as the lens to evaluate targeting strategies and real queries.
                        </div>
                    </div>

                    {openJourneyPath === "journey_1" && (
                        <div className="h-[0px] w-[724px]" style={{
                        border: "1px solid #EAEAED",
                    }}></div>)}

                    {openJourneyPath === "journey_1" && (
                    <div className="p-4 flex flex-col items-start gap-6">
                        <div className="flex items-center gap-4 self-stretch">
                            {journey_1?.slice(0,7).map(((item, index) => (
                                <div className="flex w-[90px] flex-col items-center gap-2 relative">
                                    <div className="px-2 py-[10px] w-[26px] h-[26px] flex justify-center items-center" style={{
                                        backgroundColor: "#E3F2FD",
                                        borderRadius:"20px"
                                    }}>
                                        <div
                                        style={{
                                            color: "var(--Text-Event-Blue, #1565C0)",
                                            fontFamily: "Inter",
                                            fontSize: "10px",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "10px",
                                            letterSpacing: "1.6px",
                                            textTransform: "uppercase",
                                        }}
                                        >
                                        {item?.id}
                                        </div>
                                    </div>
                                    <div
                                    style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                        textTransform: "capitalize",
                                    }}
                                    >
                                    {item?.name}
                                    </div>

                                    {index !== 6 && (
                                    <div className=" w-[40px] h-[10px]" style={{
                                        position:"absolute",
                                        left:"78px",
                                        top:"13px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="8" viewBox="0 0 42 8" fill="none">
                                            <path d="M0.987427 3.48975C0.711284 3.48975 0.487427 3.7136 0.487427 3.98975C0.487427 4.26589 0.711284 4.48975 0.987427 4.48975L0.987427 3.48975ZM41.341 4.3433C41.5362 4.14804 41.5362 3.83145 41.341 3.63619L38.159 0.454212C37.9637 0.25895 37.6472 0.25895 37.4519 0.454212C37.2566 0.649474 37.2566 0.966057 37.4519 1.16132L40.2803 3.98975L37.4519 6.81817C37.2566 7.01344 37.2566 7.33002 37.4519 7.52528C37.6472 7.72054 37.9637 7.72054 38.159 7.52528L41.341 4.3433ZM0.987427 4.48975L40.9874 4.48975L40.9874 3.48975L0.987427 3.48975L0.987427 4.48975Z" fill="#CECECF"/>
                                        </svg>
                                    </div>
                                    )}
                                </div>
                            )))}
                        </div>

                        <div className="flex items-center gap-4 self-stretch">
                            {journey_1?.slice(7, 14)?.reverse().map((item, index) => (
                                <div className="flex w-[90px] flex-col items-center gap-2 relative">
                                    <div className="px-2 py-[10px] w-[26px] h-[26px] flex justify-center items-center" style={{
                                        backgroundColor: "#E3F2FD",
                                        borderRadius:"20px"
                                    }}>
                                        <div
                                        style={{
                                            color: "var(--Text-Event-Blue, #1565C0)",
                                            fontFamily: "Inter",
                                            fontSize: "10px",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "10px",
                                            letterSpacing: "1.6px",
                                            textTransform: "uppercase",
                                        }}
                                        >
                                        {item?.id}
                                        </div>
                                    </div>
                                    <div
                                    style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                        textTransform: "capitalize",
                                    }}
                                    >
                                    {item?.name}
                                    </div>

                                    {index !== 6 && (
                                    <div className=" w-[40px] h-[10px]" style={{
                                        position:"absolute",
                                        left:"78px",
                                        top:"13px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="8" viewBox="0 0 42 8" fill="none">
                                            <path d="M40.9874 3.50806C41.2636 3.50806 41.4874 3.73191 41.4874 4.00806C41.4874 4.2842 41.2636 4.50806 40.9874 4.50806L40.9874 3.50806ZM0.633873 4.36161C0.43861 4.16635 0.43861 3.84977 0.633873 3.6545L3.81585 0.472523C4.01112 0.277261 4.3277 0.277261 4.52296 0.472523C4.71822 0.667785 4.71822 0.984367 4.52296 1.17963L1.69453 4.00806L4.52296 6.83648C4.71822 7.03175 4.71822 7.34833 4.52296 7.54359C4.3277 7.73885 4.01112 7.73885 3.81585 7.54359L0.633873 4.36161ZM40.9874 4.50806L0.987427 4.50806L0.987427 3.50806L40.9874 3.50806L40.9874 4.50806Z" fill="#CECECF"/>
                                        </svg>
                                    </div>
                                    )}
                            </div>
                            ))}
                        </div>
                    </div>)}

                    {openJourneyPath === "journey_1" && (<div className="h-4" style={{
                            position: "absolute",
                            right: "16px",
                            top: "104px"
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="78" viewBox="0 0 19 78" fill="none">
                            <path d="M1.43193 77.5794C1.48041 77.8513 1.74008 78.0324 2.01194 77.984L6.44206 77.1947C6.71391 77.1462 6.895 76.8866 6.84652 76.6147C6.79805 76.3428 6.53837 76.1617 6.26652 76.2102L2.32863 76.9118L1.62648 72.9738C1.578 72.7019 1.31833 72.5208 1.04647 72.5692C0.774617 72.6177 0.593531 72.8773 0.642006 73.1492L1.43193 77.5794ZM1.56707 0.858153C12.0205 11.528 17.0952 23.2809 17.0334 36.003C16.9716 48.7405 11.7604 62.5137 1.51404 77.2057L2.33429 77.7778C12.6502 62.9861 17.9702 49.0168 18.0334 36.008C18.0967 22.9839 12.8903 10.9869 2.28133 0.158375L1.56707 0.858153Z" fill="#CECECF"/>
                        </svg>
                    </div>)}
                </div>

                <div className="flex flex-col items-center self-stretch rounded-[8px] relative" style={{
                    border: openJourneyPath === "journey_2" ? "1px solid #1565C0" : "1px solid #EAEAED",
                    backgroundColor: "#FFF",
                    boxShadow: openJourneyPath === "journey_2" ? "0px 4px 16px 6px rgba(21, 101, 192, 0.05)"  : "none"
                }}
                >
                    <div className="p-4 rounded-[8px] flex flex-col w-full gap-1 " 
                    onClick={() => openJourneyPathHandler("journey_2")}
                    >
                        <div
                        style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "20px",
                        }}
                        >
                        Ad Placement Overview By Platform Code
                        </div>
                        <div
                        style={{
                            color: "var(--Text-Primary-Grey, #97979A)",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "18px",
                        }}
                        >
                        Understand placement performance through the lens of platform code.
                        </div>
                    </div>

                    {openJourneyPath === "journey_2" && (
                        <div className="h-[0px] w-[724px]" style={{
                        border: "1px solid #EAEAED",
                    }}></div>)}

                    {openJourneyPath === "journey_2" && (
                    <div className="p-4 flex flex-col items-start gap-6">
                        <div className="flex items-center gap-4 self-stretch">
                            {journey_2?.slice(0,7).map(((item, index) => (
                                <div className="flex w-[90px] flex-col items-center gap-2 relative">
                                    <div className="px-2 py-[10px] w-[26px] h-[26px] flex justify-center items-center" style={{
                                        backgroundColor: "#E3F2FD",
                                        borderRadius:"20px"
                                    }}>
                                        <div
                                        style={{
                                            color: "var(--Text-Event-Blue, #1565C0)",
                                            fontFamily: "Inter",
                                            fontSize: "10px",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "10px",
                                            letterSpacing: "1.6px",
                                            textTransform: "uppercase",
                                        }}
                                        >
                                        {item?.id}
                                        </div>
                                    </div>
                                    <div
                                    style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                        textTransform: "capitalize",
                                    }}
                                    >
                                    {item?.name}
                                    </div>

                                    {index !== 6 && (
                                    <div className=" w-[40px] h-[10px]" style={{
                                        position:"absolute",
                                        left:"78px",
                                        top:"13px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="8" viewBox="0 0 42 8" fill="none">
                                            <path d="M0.987427 3.48975C0.711284 3.48975 0.487427 3.7136 0.487427 3.98975C0.487427 4.26589 0.711284 4.48975 0.987427 4.48975L0.987427 3.48975ZM41.341 4.3433C41.5362 4.14804 41.5362 3.83145 41.341 3.63619L38.159 0.454212C37.9637 0.25895 37.6472 0.25895 37.4519 0.454212C37.2566 0.649474 37.2566 0.966057 37.4519 1.16132L40.2803 3.98975L37.4519 6.81817C37.2566 7.01344 37.2566 7.33002 37.4519 7.52528C37.6472 7.72054 37.9637 7.72054 38.159 7.52528L41.341 4.3433ZM0.987427 4.48975L40.9874 4.48975L40.9874 3.48975L0.987427 3.48975L0.987427 4.48975Z" fill="#CECECF"/>
                                        </svg>
                                    </div>
                                    )}
                                </div>
                            )))}
                        </div>

                        <div className="flex items-center justify-end gap-4 self-stretch">
                            {journey_2?.slice(7, 14)?.reverse().map((item, index) => (
                                <div className="flex w-[90px] flex-col items-center gap-2 relative">
                                    <div className="px-2 py-[10px] w-[26px] h-[26px] flex justify-center items-center" style={{
                                        backgroundColor: "#E3F2FD",
                                        borderRadius:"20px"
                                    }}>
                                        <div
                                        style={{
                                            color: "var(--Text-Event-Blue, #1565C0)",
                                            fontFamily: "Inter",
                                            fontSize: "10px",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "10px",
                                            letterSpacing: "1.6px",
                                            textTransform: "uppercase",
                                        }}
                                        >
                                        {item?.id}
                                        </div>
                                    </div>
                                    <div
                                    style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                        textTransform: "capitalize",
                                    }}
                                    >
                                    {item?.name}
                                    </div>

                                    {index !== 4 && (
                                    <div className=" w-[40px] h-[10px]" style={{
                                        position:"absolute",
                                        left:"78px",
                                        top:"13px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="8" viewBox="0 0 42 8" fill="none">
                                            <path d="M40.9874 3.50806C41.2636 3.50806 41.4874 3.73191 41.4874 4.00806C41.4874 4.2842 41.2636 4.50806 40.9874 4.50806L40.9874 3.50806ZM0.633873 4.36161C0.43861 4.16635 0.43861 3.84977 0.633873 3.6545L3.81585 0.472523C4.01112 0.277261 4.3277 0.277261 4.52296 0.472523C4.71822 0.667785 4.71822 0.984367 4.52296 1.17963L1.69453 4.00806L4.52296 6.83648C4.71822 7.03175 4.71822 7.34833 4.52296 7.54359C4.3277 7.73885 4.01112 7.73885 3.81585 7.54359L0.633873 4.36161ZM40.9874 4.50806L0.987427 4.50806L0.987427 3.50806L40.9874 3.50806L40.9874 4.50806Z" fill="#CECECF"/>
                                        </svg>
                                    </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>)}

                    {openJourneyPath === "journey_2" && (<div className="h-4" style={{
                            position: "absolute",
                            right: "16px",
                            top: "104px"
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="78" viewBox="0 0 19 78" fill="none">
                            <path d="M1.43193 77.5794C1.48041 77.8513 1.74008 78.0324 2.01194 77.984L6.44206 77.1947C6.71391 77.1462 6.895 76.8866 6.84652 76.6147C6.79805 76.3428 6.53837 76.1617 6.26652 76.2102L2.32863 76.9118L1.62648 72.9738C1.578 72.7019 1.31833 72.5208 1.04647 72.5692C0.774617 72.6177 0.593531 72.8773 0.642006 73.1492L1.43193 77.5794ZM1.56707 0.858153C12.0205 11.528 17.0952 23.2809 17.0334 36.003C16.9716 48.7405 11.7604 62.5137 1.51404 77.2057L2.33429 77.7778C12.6502 62.9861 17.9702 49.0168 18.0334 36.008C18.0967 22.9839 12.8903 10.9869 2.28133 0.158375L1.56707 0.858153Z" fill="#CECECF"/>
                        </svg>
                    </div>)}
                </div>

                <div className="flex flex-col items-center self-stretch rounded-[8px] relative" style={{
                    border: openJourneyPath === "journey_3" ? "1px solid #1565C0" : "1px solid #EAEAED",
                    backgroundColor: "#FFF",
                    boxShadow: openJourneyPath === "journey_3" ? "0px 4px 16px 6px rgba(21, 101, 192, 0.05)"  : "none"
                }}
                >
                    <div className="p-4 rounded-[8px] flex flex-col w-full gap-1 " 
                    onClick={() => openJourneyPathHandler("journey_3")}
                    >
                        <div
                        style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "20px",
                        }}
                        >
                        Search Term Exploration By Product Name
                        </div>
                        <div
                        style={{
                            color: "var(--Text-Primary-Grey, #97979A)",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "18px",
                        }}
                        >
                        Follow the path from product to user search behaviour across campaigns.
                        </div>
                    </div>

                    {openJourneyPath === "journey_3" && (
                        <div className="h-[0px] w-[724px]" style={{
                        border: "1px solid #EAEAED",
                    }}></div>)}

                    {openJourneyPath === "journey_3" && (
                    <div className="p-4 flex flex-col items-start gap-6">
                        <div className="flex items-center gap-4 self-stretch">
                            {journey_3?.slice(0,7).map(((item, index) => (
                                <div className="flex w-[90px] flex-col items-center gap-2 relative">
                                    <div className="px-2 py-[10px] w-[26px] h-[26px] flex justify-center items-center" style={{
                                        backgroundColor: "#E3F2FD",
                                        borderRadius:"20px"
                                    }}>
                                        <div
                                        style={{
                                            color: "var(--Text-Event-Blue, #1565C0)",
                                            fontFamily: "Inter",
                                            fontSize: "10px",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "10px",
                                            letterSpacing: "1.6px",
                                            textTransform: "uppercase",
                                        }}
                                        >
                                        {item?.id}
                                        </div>
                                    </div>
                                    <div
                                    style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                        textTransform: "capitalize",
                                    }}
                                    >
                                    {item?.name}
                                    </div>

                                    {index !== 6 && (
                                    <div className=" w-[40px] h-[10px]" style={{
                                        position:"absolute",
                                        left:"78px",
                                        top:"13px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="8" viewBox="0 0 42 8" fill="none">
                                            <path d="M0.987427 3.48975C0.711284 3.48975 0.487427 3.7136 0.487427 3.98975C0.487427 4.26589 0.711284 4.48975 0.987427 4.48975L0.987427 3.48975ZM41.341 4.3433C41.5362 4.14804 41.5362 3.83145 41.341 3.63619L38.159 0.454212C37.9637 0.25895 37.6472 0.25895 37.4519 0.454212C37.2566 0.649474 37.2566 0.966057 37.4519 1.16132L40.2803 3.98975L37.4519 6.81817C37.2566 7.01344 37.2566 7.33002 37.4519 7.52528C37.6472 7.72054 37.9637 7.72054 38.159 7.52528L41.341 4.3433ZM0.987427 4.48975L40.9874 4.48975L40.9874 3.48975L0.987427 3.48975L0.987427 4.48975Z" fill="#CECECF"/>
                                        </svg>
                                    </div>
                                    )}
                                </div>
                            )))}
                        </div>

                        <div className="flex items-center justify-end gap-4 self-stretch">
                            {journey_3?.slice(7, 14)?.reverse().map((item, index) => (
                                <div className="flex w-[90px] flex-col items-center gap-2 relative">
                                    <div className="px-2 py-[10px] w-[26px] h-[26px] flex justify-center items-center" style={{
                                        backgroundColor: "#E3F2FD",
                                        borderRadius:"20px"
                                    }}>
                                        <div
                                        style={{
                                            color: "var(--Text-Event-Blue, #1565C0)",
                                            fontFamily: "Inter",
                                            fontSize: "10px",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "10px",
                                            letterSpacing: "1.6px",
                                            textTransform: "uppercase",
                                        }}
                                        >
                                        {item?.id}
                                        </div>
                                    </div>
                                    <div
                                    style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                        textTransform: "capitalize",
                                    }}
                                    >
                                    {item?.name}
                                    </div>

                                    {index !== 1 && (
                                    <div className=" w-[40px] h-[10px]" style={{
                                        position:"absolute",
                                        left:"78px",
                                        top:"13px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="8" viewBox="0 0 42 8" fill="none">
                                            <path d="M40.9874 3.50806C41.2636 3.50806 41.4874 3.73191 41.4874 4.00806C41.4874 4.2842 41.2636 4.50806 40.9874 4.50806L40.9874 3.50806ZM0.633873 4.36161C0.43861 4.16635 0.43861 3.84977 0.633873 3.6545L3.81585 0.472523C4.01112 0.277261 4.3277 0.277261 4.52296 0.472523C4.71822 0.667785 4.71822 0.984367 4.52296 1.17963L1.69453 4.00806L4.52296 6.83648C4.71822 7.03175 4.71822 7.34833 4.52296 7.54359C4.3277 7.73885 4.01112 7.73885 3.81585 7.54359L0.633873 4.36161ZM40.9874 4.50806L0.987427 4.50806L0.987427 3.50806L40.9874 3.50806L40.9874 4.50806Z" fill="#CECECF"/>
                                        </svg>
                                    </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>)}

                    {openJourneyPath === "journey_3" && (<div className="h-4" style={{
                            position: "absolute",
                            right: "16px",
                            top: "104px"
                        }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="78" viewBox="0 0 19 78" fill="none">
                            <path d="M1.43193 77.5794C1.48041 77.8513 1.74008 78.0324 2.01194 77.984L6.44206 77.1947C6.71391 77.1462 6.895 76.8866 6.84652 76.6147C6.79805 76.3428 6.53837 76.1617 6.26652 76.2102L2.32863 76.9118L1.62648 72.9738C1.578 72.7019 1.31833 72.5208 1.04647 72.5692C0.774617 72.6177 0.593531 72.8773 0.642006 73.1492L1.43193 77.5794ZM1.56707 0.858153C12.0205 11.528 17.0952 23.2809 17.0334 36.003C16.9716 48.7405 11.7604 62.5137 1.51404 77.2057L2.33429 77.7778C12.6502 62.9861 17.9702 49.0168 18.0334 36.008C18.0967 22.9839 12.8903 10.9869 2.28133 0.158375L1.56707 0.858153Z" fill="#CECECF"/>
                        </svg>
                    </div>)}
                </div>

                <div className="flex flex-col items-center self-stretch rounded-[8px] relative" style={{
                    border: openJourneyPath === "journey_4" ? "1px solid #1565C0" : "1px solid #EAEAED",
                    backgroundColor: "#FFF",
                    boxShadow: openJourneyPath === "journey_4" ? "0px 4px 16px 6px rgba(21, 101, 192, 0.05)"  : "none"
                }}
                >
                    <div className="p-4 rounded-[8px] flex flex-col w-full gap-1 " 
                    onClick={() => openJourneyPathHandler("journey_4")}
                    >
                        <div
                        style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "20px",
                        }}
                        >
                        Product-Level Campaign & Placement Analysis
                        </div>
                        <div
                        style={{
                            color: "var(--Text-Primary-Grey, #97979A)",
                            fontFamily: "Inter",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "18px",
                        }}
                        >Follow a product from campaign inclusion to its placement locations.
                        </div>
                    </div>

                    {openJourneyPath === "journey_4" && (
                        <div className="h-[0px] w-[724px]" style={{
                        border: "1px solid #EAEAED",
                    }}></div>)}

                    {openJourneyPath === "journey_4" && (
                    <div className="p-4 flex flex-col items-start gap-6">
                        <div className="flex items-center gap-4 self-stretch">
                            {journey_4?.slice(0,7).map(((item, index) => (
                                <div className="flex w-[90px] flex-col items-center gap-2 relative">
                                    <div className="px-2 py-[10px] w-[26px] h-[26px] flex justify-center items-center" style={{
                                        backgroundColor: "#E3F2FD",
                                        borderRadius:"20px"
                                    }}>
                                        <div
                                        style={{
                                            color: "var(--Text-Event-Blue, #1565C0)",
                                            fontFamily: "Inter",
                                            fontSize: "10px",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "10px",
                                            letterSpacing: "1.6px",
                                            textTransform: "uppercase",
                                        }}
                                        >
                                        {item?.id}
                                        </div>
                                    </div>
                                    <div
                                    style={{
                                        color: "var(--Text-Primary-Black, #1C1C1E)",
                                        textAlign: "center",
                                        fontFamily: "Inter",
                                        fontSize: "10px",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                        textTransform: "capitalize",
                                    }}
                                    >
                                    {item?.name}
                                    </div>

                                    {index !== 6 && (
                                    <div className=" w-[40px] h-[10px]" style={{
                                        position:"absolute",
                                        left:"78px",
                                        top:"13px"
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="8" viewBox="0 0 42 8" fill="none">
                                            <path d="M0.987427 3.48975C0.711284 3.48975 0.487427 3.7136 0.487427 3.98975C0.487427 4.26589 0.711284 4.48975 0.987427 4.48975L0.987427 3.48975ZM41.341 4.3433C41.5362 4.14804 41.5362 3.83145 41.341 3.63619L38.159 0.454212C37.9637 0.25895 37.6472 0.25895 37.4519 0.454212C37.2566 0.649474 37.2566 0.966057 37.4519 1.16132L40.2803 3.98975L37.4519 6.81817C37.2566 7.01344 37.2566 7.33002 37.4519 7.52528C37.6472 7.72054 37.9637 7.72054 38.159 7.52528L41.341 4.3433ZM0.987427 4.48975L40.9874 4.48975L40.9874 3.48975L0.987427 3.48975L0.987427 4.48975Z" fill="#CECECF"/>
                                        </svg>
                                    </div>
                                    )}
                                </div>
                            )))}
                        </div>
                    </div>)}

                </div>

            </div>

            <div className="flex items-start justify-center gap-[30px] self-stretch">
            <Button
                color="neutral"
                sx={{
                height: "40px",
                width: "50%",
                backgroundColor: "#FFF",
                ":hover": {
                    backgroundColor: "#FFF",
                },
                color: "#1C1C1E",
                borderRadius: "8px",
                border: "1px solid #F2F2F5",
                padding: "0px 8px",
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: "18px",
                }}
                onClick={() => setToggle(false)}
            >
                Cancel
            </Button>
            <Button
                onClick={() => DrillThroughHandler(openJourneyPath)}
                sx={{
                height: "40px",
                width: "50%",
                backgroundColor: "#1565C0",
                color: "#FFF",
                borderRadius: "8px",
                padding: "0px 8px",
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: "18px",
                }}
                disabled = {openJourneyPath === ""}
            >
                Proceed
            </Button>
            </div>
            </div>
            <div
            className="absolute top-4 right-4 flex p-1 "
            style={{
                zIndex: 100,
                backgroundColor: "#F2F2F5",
                borderRadius: "20px"
            }}
            >
            <img
                src={CrossIcon}
                alt="OverView Icon"
                style={{ cursor: "pointer" }}
                onClick={() => setToggle(false)}

            />
            </div>
        </div>
        </Modal>
    );
};

export default DrillThroughJourneyModal;
